import { Tabs } from "antd";
import React from "react";
import ArticleSeo from "./ArticleSeo";
import CateArticleSeo from "./CateArticleSeo";
import CateProductSeo from "./CateProductSeo";
import HomeSeo from "./HomeSeo";
import ProductSeo from "./ProductSeo";

const SeoPage = (props) => {
  const { TabPane } = Tabs;

  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Trang Chủ SEO" key="1">
        <HomeSeo />
      </TabPane>
      <TabPane tab="Sản phẩm SEO" key="2">
        <ProductSeo />
      </TabPane>
      {/* <TabPane tab="Danh mục sản phẩm SEO" key="3">
        <CateProductSeo />
      </TabPane> */}
      <TabPane tab="Hỏi đáp SEO" key="4">
        <ArticleSeo />
      </TabPane>
      {/* <TabPane tab="Danh mục hỏi đáp SEO" key="5">
        <CateArticleSeo />
      </TabPane> */}
    </Tabs>
  );
};

export default SeoPage;
